<div class="min-h-screen bg-surface flex flex-col py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-fg-primary">
      Wähle die Organisation für die du arbeiten möchtest
    </h2>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-surface py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <div class="max-w-sm w-full bg-surface shadow-lg rounded-lg pointer-events-auto">
        @if (organisations$ | async; as orgas) {
          <div>
            @for (organisation of orgas; track organisation) {
              <div
                class="rounded-lg ring-1 ring-black/5 overflow-hidden cursor-pointer"
                (click)="setOrganisation(organisation.id)"
              >
                <div class="p-4">
                  <div class="flex items-center">
                    <div class="flex-shrink-0">
                      @if (organisation.id !== selectedOrganisationId) {
                        <svg
                          class="h-6 w-6 text-fg-secondary"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M 21 12 a 9 9 0 1 1 -18 0 a 9 9 0 0 1 18 0 z"
                          />
                        </svg>
                      }
                      @if (organisation.id === selectedOrganisationId) {
                        <app-ng-icon
                          class="text-2xl text-green-400"
                          strokeWidth="2"
                          name="heroCheckCircle"
                        ></app-ng-icon>
                      }
                    </div>
                    <div class="ml-3 w-0 flex-1 pt-0.5">
                      <p class="text-sm leading-5 font-medium text-fg-primary">
                        {{ organisation.name }}
                        <span class="font-small text-fg-muted">({{ organisation.id }})</span>
                      </p>
                      @if (organisation.role !== 'not authorized by jessie') {
                        <p class="mt-1 text-sm leading-5 text-fg-secondary">
                          Rolle: {{ organisation.role }}
                        </p>
                      } @else {
                        <p class="mt-1 text-sm leading-5 text-fg-secondary">
                          jessie.ai ist zurzeit in Erprobung. <br />
                          Daher werden alle Accounts manuell überprüft. <br />
                          Wir freuen uns auf Early Adopters, bitte melde dich doch mit deiner Login
                          E-Mailadresse bei early&#64;jessie.ai.
                        </p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          loading
        }
      </div>

      <div class="mt-6">
        <p class="text-xs text-center mb-4">
          Indem du jessie.ai nutzt, stimmst du unseren
          <a class="underline" target="_blank" href="../assets/jessie_ai_agb.pdf"
            >Allgemeinen Geschäftsbedingungen</a
          >
          zu.
        </p>
        <button
          class="w-full justify-center"
          appTailwindButton
          [disabled]="!selectedOrganisationId"
          (click)="onSubmit()"
        >
          Auswählen
        </button>
      </div>
    </div>
    <div class="flex justify-center text-xs mt-2 text-fg-secondary">
      <a
        [routerLink]="['/user', 'logout']"
        [relativeTo]="null"
        class="no-underline hover:underline"
      >
        User {{ loggedInUserEmail$ | async }} ausloggen</a
      >
    </div>
  </div>
</div>
